import React from 'react'

import { DateFormat } from '@/components/date-format.tsx'
import { Attribute } from '@/features/attributes/types.ts'
import {
  DynamicDataRenderer,
  DynamicObject,
} from '@/routes/_authenticated/documents/$documentId/-components/dynamic-data-renderer/dynamic-data-renderer.tsx'

export function isComplexDataType(
  attributeJsonSchema?: Attribute['json_schema']
) {
  const isObject = attributeJsonSchema?.type === 'object'
  const isArrayOfObjects =
    attributeJsonSchema?.type === 'array' &&
    ['object', 'array'].includes(attributeJsonSchema?.items?.type)

  return isObject || isArrayOfObjects
}

export const DocumentAttributeRender: React.FC<{
  attributeJsonSchema?: Attribute['json_schema']
  value: unknown
}> = ({ attributeJsonSchema, value }) => {
  const type = attributeJsonSchema?.type
  if (
    attributeJsonSchema &&
    attributeJsonSchema.type === 'string' &&
    ['date', 'datetime'].includes(attributeJsonSchema.format!)
  ) {
    return <DateFormat date={value?.toString()} />
  }

  if (type === 'boolean') {
    return value === 'true' || value === true ? 'Si' : 'No'
  }

  if (isComplexDataType(attributeJsonSchema)) {
    return <DynamicDataRenderer data={value as DynamicObject} />
  }

  return (Array.isArray(value) ? value : [value]).join(', ')
}
